import React from "react";
import {Controller} from "react-hook-form";
import {FormControl, TextField, Tooltip} from "@material-ui/core";

export default function RetryCountFormField({control, errors}) {
  return (
    <FormControl>
      <Controller
        name="retryCount"
        control={control}
        render={({field}) => (
          <Tooltip title="The number of tries to run the script before considering it hard failed" arrow>
            <TextField
              {...field}
              fullWidth
              label="Retries"
              error={!!errors.retryCount}
              helperText={errors.retryCount && errors.retryCount?.message}
              type="number"
              variant="outlined"
              InputProps={{
                inputProps: {
                  min: 0
                }
              }}
            />
          </Tooltip>
        )}
      />
    </FormControl>
  );
}
